import { RangeBar } from '@repo/ui';
import { Card, Typography } from 'components';
import filterNonZeroImpactMetrics from '../utils/filterNonZeroImpactMetrics';
import { GroupedMicrobiomeAge } from '../utils/groupMicrobiomeAgeResponse';
import styles from './Factor.module.css';
import FactorMetrics from './FactorMetrics';

const MAGNITUDE_YEARS = 10;

interface FactorProps {
  factor: GroupedMicrobiomeAge[number];
}

export default function Factor({ factor }: FactorProps) {
  const years = factor.contribution_years;
  const sign = years > 0 ? '+' : '';
  const filteredMetrics = filterNonZeroImpactMetrics(factor.metrics);
  const hasImpact = filteredMetrics.length > 0;
  const valueDisplay = hasImpact ? +years.toFixed(1) : 0;

  return (
    <Card>
      <div className={styles.factor}>
        <Typography variant='body-s' weight='medium'>
          {factor.section?.display_title}
        </Typography>
        <Typography variant='body-xs' color='dark'>
          Impact on microbiome age
        </Typography>
        <RangeBar
          ranges={[
            {
              range_lower: -MAGNITUDE_YEARS,
              range_upper: 0,
              evaluation_color: 'green',
            },
            {
              range_lower: 0,
              range_upper: MAGNITUDE_YEARS,
              evaluation_color: 'red',
            },
          ]}
          value={valueDisplay}
          showValue
          formatBreakpoint={n => String(n)}
        />
        <div className={styles.divider} />
        <Typography variant='body-xs' color='grey'>
          Metrics moving your microbiome age
        </Typography>
        {hasImpact ? (
          <FactorMetrics metrics={filteredMetrics} />
        ) : (
          <Typography variant='body-xs' color='dark'>
            There are no metrics in this category that are impacting your
            microbiome age.
          </Typography>
        )}
        {(factor.collapsed_count ?? 0) > 0 ? (
          <Typography variant='body-xs' color='grey'>
            + {factor.collapsed_count} other factors with minimal impact
          </Typography>
        ) : null}
      </div>
    </Card>
  );
}
